export default __webpack_public_path__ + "static/media/video1.fff44c9d.jpg";